<template lang='pug'>
  #GPT.main-page.GPT-color.page-noScroll.pb-0.position-relative
    //- loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    v-row#page-head.d-flex.align-center.justify-md-space-between
      v-col.d-flex.align-center.px-0.pb-0.px-md-3.pb-md-4(cols='3' md='3')
        h1.my-0(style="font-weight: 700; font-size: 28px; white-space: nowrap;") {{$t('GPT_MENU.USER_MANAGEMENT')}}
        v-btn.ml-5.white--text(v-if="this.isADFS" @click="entraIDSync()" height='40' :ripple='false' color='#14C6DE' depressed)
          v-img(src="../assets/images/entra_id_sync.svg" max-width="24px" width="24px").mr-1
          span(style='font-weight: 700; font-size: 16px;') Entra ID Sync
    #page-inner.scroll-x.pb-0.height_100vh
      .upload_page_height.scrollbar.px-3(style='padding-top:10px;')
          v-container.pa-1.upload_page-container(max-content)
            v-card.rounded-card.pa-0.ma-0
              gptManageUsers(ref='gptManageUsers')
    v-dialog(v-model='showEntraIDSyncDialog' width='1200' :persistent='syncLoading')
      EntraIDSyncDialog(:users='users' @closeSyncDialog='closeSyncDialog()' @syncLoading='syncLoading = $event')
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    
</template>

<script>
import refreshBtn from "@/components/Common/refreshBtn";
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import PreferenceService from "@/services/PreferenceService";
import PermissionService from "@/services/PermissionService";
import EntraIDSyncDialog from '@/components/GPT_Dialog/EntraIDSync/entraIDSync';
// import i18n from '/common/plugins/vue-i18n.js';
import gptManageUsers from "../components/GPT_Common/gptManageUsers.vue";

export default {
  components: {
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    refreshBtn,
    gptManageUsers,
    EntraIDSyncDialog,
  },
  data() {
    return {
      // other
      loading:false,
      isDelete:false,
      // Dialog
      addDialog:false,
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      // Data
      showEntraIDSyncDialog: false,
      entraIDSyncDialog: false,
      syncLoading: false,
      users: [],
      isADFS: true,
    }
  },
  async created() {
    await PreferenceService.isADFSLogin()
    .then(response =>{
        this.isADFS = response.data === "ADFS";
    });
  },
  destroyed() {
  },
  methods: {
    // Dialog Area ----------------------------------------- [Start]
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog() {
      this.messageDialog = false;
    },
    async onEmitRefresh(){
        this.loading = true;
        await this.getKnowledgeList();
        await this.getListData();
        this.loading = false;
    },
    closeSyncDialog(){
      this.showEntraIDSyncDialog = false;
      this.$refs.gptManageUsers.getManageUserList();
    },
    async entraIDSync() {
      this.showEntraIDSyncDialog = true;
      await PermissionService.getADFSUsers()
      .then((response) => {
        this.users = response.data.map(user => ({
          email: user.userPrincipalName || '',
          first_name: user.givenName || '',
          last_name: user.surname || '',
          job_title: user.jobTitle || '',
          business_phones: user.businessPhones || '',
          office_location: user.officeLocation || '',
          sync: user.sync,
          user_id: user.user_id || null,
          is_portal_user: user.is_portal_user || false,
          portal_user_selection: user.is_portal_user || false,
          fromUpgpt: true,
          is_staff: false,
          valid: true,
          username: user.userPrincipalName,
        }));
      })
      .catch((error) => {
        console.error('取得 AD 使用者失敗:', error);
      });
    }
  },
  watch:{
  }
};
</script>